import type { FC } from 'react';
import { ShimmerBar, SkeletonContainer } from './SkeletonContent.styles';

export const SkeletonContent: FC = () => (
    <SkeletonContainer data-testid="alt-deal-cell-skeleton">
        <ShimmerBar $height="10px" />
        <ShimmerBar $height="20px" $width="60%" />
        <ShimmerBar $height="10px" />
    </SkeletonContainer>
);
